module.exports = __webpack_public_path__ + "img/BAY.1afd51ed.svg";